 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSHTMLCOVERPAGE from '@/components/OEBPS/html/coverpage'
 import OEBPSHTML9780230249226_01_HLF from '@/components/OEBPS/html/9780230249226_01_hlf'
 import LOVE_1 from '@/components/love_1'
 import OEBPSHTML9780230249226_02_TTL from '@/components/OEBPS/html/9780230249226_02_ttl'
 import OEBPSHTMLNOTICE from '@/components/OEBPS/html/notice'
 import OEBPSHTML9780230249226_04_TOC from '@/components/OEBPS/html/9780230249226_04_toc'
 import OEBPSHTML9780230249226_05_INT from '@/components/OEBPS/html/9780230249226_05_int'
 import OEBPSHTML9780230249226_06_CHP01 from '@/components/OEBPS/html/9780230249226_06_chp01'
 import OEBPSHTML9780230249226_07_CHP02 from '@/components/OEBPS/html/9780230249226_07_chp02'
 import OEBPSHTML9780230249226_08_CHP03 from '@/components/OEBPS/html/9780230249226_08_chp03'
 import OEBPSHTML9780230249226_09_CHP04 from '@/components/OEBPS/html/9780230249226_09_chp04'
 import OEBPSHTML9780230249226_10_CHP05 from '@/components/OEBPS/html/9780230249226_10_chp05'
 import OEBPSHTML9780230249226_11_CHP06 from '@/components/OEBPS/html/9780230249226_11_chp06'
 import OEBPSHTML9780230249226_12_CHP07 from '@/components/OEBPS/html/9780230249226_12_chp07'
 import LOVE_2 from '@/components/love_2'
 import OEBPSHTML9780230249226_13_APP from '@/components/OEBPS/html/9780230249226_13_app'
 import OEBPSHTML9780230249226_14_ABB from '@/components/OEBPS/html/9780230249226_14_abb'
 import OEBPSHTML9780230249226_15_NOT from '@/components/OEBPS/html/9780230249226_15_not'
 import OEBPSHTML9780230249226_16_IND from '@/components/OEBPS/html/9780230249226_16_ind'
 import OEBPSHTML9780230249226_03_IMP from '@/components/OEBPS/html/9780230249226_03_imp'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/html/coverpage",
 			"name" : "OEBPS/html/coverpage",
 			"component" : OEBPSHTMLCOVERPAGE
 		},
 		{
 			"path" : "/OEBPS/html/9780230249226_01_hlf",
 			"name" : "OEBPS/html/9780230249226_01_hlf",
 			"component" : OEBPSHTML9780230249226_01_HLF
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/html/9780230249226_02_ttl",
 			"name" : "OEBPS/html/9780230249226_02_ttl",
 			"component" : OEBPSHTML9780230249226_02_TTL
 		},
 		{
 			"path" : "/OEBPS/html/notice",
 			"name" : "OEBPS/html/notice",
 			"component" : OEBPSHTMLNOTICE
 		},
 		{
 			"path" : "/OEBPS/html/9780230249226_04_toc",
 			"name" : "OEBPS/html/9780230249226_04_toc",
 			"component" : OEBPSHTML9780230249226_04_TOC
 		},
 		{
 			"path" : "/OEBPS/html/9780230249226_05_int",
 			"name" : "OEBPS/html/9780230249226_05_int",
 			"component" : OEBPSHTML9780230249226_05_INT
 		},
 		{
 			"path" : "/OEBPS/html/9780230249226_06_chp01",
 			"name" : "OEBPS/html/9780230249226_06_chp01",
 			"component" : OEBPSHTML9780230249226_06_CHP01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js